import React, { useState } from "react";

const ErrataDisplay = ({ erratas }) => {
    const [expanded, setExpanded] = useState(false);

    if (!erratas || erratas.length === 0) return null;

    return (
        <div>
            <button
                onClick={() => setExpanded(!expanded)}
                className="flex items-center gap-2 w-full text-left cursor-pointer"
            >
                <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 text-amber-500 shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                </svg>
                <span className="text-sm font-medium text-amber-700">Important Information ({erratas.length})</span>
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className={`h-4 w-4 text-amber-500 ml-auto transition-transform duration-200 ${expanded ? "rotate-180" : ""}`}
                    fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2"
                >
                    <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" />
                </svg>
            </button>
            {expanded && (
                <div className="space-y-2 mt-3">
                    {erratas.map((errata, eIdx) => (
                        <div key={eIdx} className="flex gap-2.5 bg-amber-50 border border-amber-200 rounded-lg p-3">
                            <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 text-amber-500 shrink-0 mt-0.5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
                                <path strokeLinecap="round" strokeLinejoin="round" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                            </svg>
                            {/* min-w-0 + break-words: passport/visa notices carry long unbroken URLs that would
                                otherwise set the column's min-content width and spill outside the card on phones. */}
                            <div className="min-w-0 flex-1">
                                <p className="text-xs font-semibold text-amber-700 break-words">{errata.subject}</p>
                                <p className="text-xs text-amber-600 mt-0.5 leading-relaxed break-words">{errata.description}</p>
                            </div>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};

export default ErrataDisplay;
